(() => {
  if (window.StoreExpertsProductShippingLoaded) return;
  window.StoreExpertsProductShippingLoaded = true;

  const ufMap = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo',
    GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba',
    PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul',
    RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins'
  };

  const formatCep = (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
  };

  const moneyBR = (value) => {
    if (value === 0 || value === '0' || value === '0.00') return 'Grátis';
    const raw = String(value || '').replace(/[^\d.,-]/g, '');
    let parsed;
    if (raw.includes('.') && raw.includes(',')) parsed = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
    else if (raw.includes(',')) parsed = parseFloat(raw.replace(',', '.'));
    else parsed = parseFloat(raw);
    if (Number.isNaN(parsed)) return String(value || '');
    return parsed.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const setMessage = (root, text, isError = false) => {
    const message = root.querySelector('.se-product-shipping__message');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  };

  const clearResult = (root) => {
    const result = root.querySelector('.se-product-shipping__result');
    if (result) result.innerHTML = '';
  };

  const setLoading = (root, state) => {
    const button = root.querySelector('.se-product-shipping__button');
    if (!button) return;
    if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent.trim() || 'Calcular';
    button.classList.toggle('is-loading', Boolean(state));
    button.disabled = Boolean(state);
    button.textContent = state ? 'Calculando...' : button.dataset.defaultText;
  };

  const getVariantId = (root) => {
    const form = root.closest('.product__info-container')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput?.value) return variantInput.value;
    try {
      return new URL(window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  };

  const fetchAddress = async (zip) => {
    const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, { headers: { Accept: 'application/json' } });
    const data = await response.json();
    if (!data || data.erro) throw new Error('CEP não encontrado. Verifique o número e tente novamente.');
    const province = ufMap[data.uf];
    if (!province) throw new Error('Não foi possível identificar o estado do CEP.');
    const address = [data.logradouro, data.bairro, data.localidade, data.uf].filter(Boolean).join(' - ');
    return { province, address };
  };

  const requestRates = async (zip, province, country) => {
    const response = await fetch('/cart/shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ shipping_address: { zip, country, province } })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data?.message || 'Não foi possível calcular o frete.');
    return data;
  };

  const addTemporaryVariant = async (variantId) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
      body: `id=${encodeURIComponent(variantId)}&quantity=1`
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data?.description || data?.message || 'Selecione uma variação disponível para calcular o frete.');
    return data;
  };

  const clearTemporaryCart = async () => {
    await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const renderRates = (root, rates, address) => {
    const result = root.querySelector('.se-product-shipping__result');
    clearResult(root);
    if (address) setMessage(root, address, false);
    if (!Array.isArray(rates) || !rates.length) {
      setMessage(root, 'Não encontramos opções de entrega para este CEP.', true);
      return;
    }
    const ul = document.createElement('ul');
    ul.className = 'se-product-shipping__rates';
    rates.forEach((rate) => {
      const li = document.createElement('li');
      li.className = 'se-product-shipping__rate';
      const row = document.createElement('div');
      row.className = 'se-product-shipping__rate-row';
      const name = document.createElement('span');
      name.className = 'se-product-shipping__rate-name';
      name.textContent = rate.name || 'Entrega';
      const price = document.createElement('span');
      price.className = 'se-product-shipping__rate-price';
      price.textContent = moneyBR(rate.price);
      row.append(name, price);
      li.append(row);
      if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
        const days = parseInt(rate.delivery_days[0], 10);
        if (!Number.isNaN(days)) {
          const meta = document.createElement('span');
          meta.className = 'se-product-shipping__rate-meta';
          meta.textContent = `Entrega em até ${days} dias úteis`;
          li.append(meta);
        }
      }
      ul.append(li);
    });
    result?.append(ul);
  };

  const calculate = async (root) => {
    const input = root.querySelector('.se-product-shipping__input');
    const zip = String(input?.value || '').replace(/\D/g, '').slice(0, 8);
    const country = root.dataset.country || 'Brazil';
    clearResult(root);
    setMessage(root, '', false);
    if (zip.length !== 8) {
      setMessage(root, 'Por favor, informe um CEP válido com 8 dígitos.', true);
      return;
    }
    setLoading(root, true);
    let addedTemporary = false;
    try {
      const info = await fetchAddress(zip);
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      if (!cart || Number(cart.item_count || 0) === 0) {
        const variantId = getVariantId(root);
        if (!variantId) throw new Error('Selecione uma variação disponível para calcular o frete.');
        await addTemporaryVariant(variantId);
        addedTemporary = true;
      }
      const data = await requestRates(zip, info.province, country);
      renderRates(root, data.shipping_rates, info.address);
    } catch (error) {
      clearResult(root);
      setMessage(root, error?.message || 'Ocorreu um erro ao calcular o frete.', true);
    } finally {
      if (addedTemporary) await clearTemporaryCart();
      setLoading(root, false);
    }
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('.se-product-shipping__input');
    if (!input) return;
    input.value = formatCep(input.value);
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest?.('.se-product-shipping__input');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    const root = input.closest('[data-se-product-shipping]');
    if (root) calculate(root);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.se-product-shipping__button');
    if (!button) return;
    const root = button.closest('[data-se-product-shipping]');
    if (root) calculate(root);
  });
})();
